<template>
    <paper class="dispatch">
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="vehicleFreePlatform"
            :currentPage="currentPage"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @searchChange="searchChange"
            @selectChange="selectChange">
            <div slot="page-module-btn">
                <el-button type="primary" @click="binding" v-has="'05060001'">设备绑定</el-button>
                <el-button type="primary" @click="recycle" v-has="'05060002'">设备回收</el-button>
            </div>
        </m-pane>
        <el-dialog
            title="输入设备号"
            :visible.sync="visible"
            width="30%"
            @close="handleClose">
            <el-form
                ref="form"
                inline
                :model="ruleForm"
                label-position="right"
                label-width="100px"
                :rules="rules">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="设备号" prop='deviceName'>
                            <el-input v-model="ruleForm.deviceName" style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="handleChange" :loading="saveLoading">确 定</el-button>
            </span>
        </el-dialog>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/supplierPanel';
import { getList, bundDevice, recallDevice } from '../../api/equipment';
import config from './config.js';
import common from '../../common/common';
import { mapGetters } from 'vuex';
const { getSessionKey, initSessionData } = common;
export default {
    name: 'equipment',
    components: { paper, mPane },
    mounted() {
        initSessionData([
            'SYS_LMDM_PRIOR_LEVEL',
            'SYS_TMS_TRANSPORT_TYPE',
            'SYS_SUPPLIER_YES_NO',
            'SYS_TRANSPORT_TASK_STATUS'
        ]);
    },
    computed: {
        ...mapGetters(['supplier', 'user'])
    },
    data() {
        return {
            config,
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页数量
            ettaContractNo: '', // 搜索的合同编号
            selectArray: [], // 已选集合
            visible: false,
            saveLoading: false,
            flagText: '',
            ruleForm: {
                deviceName: ''
            },
            rules: {
                deviceName: [
                    { required: true, message: '请输入设备号', trigger: 'change' }
                ]
            }
        };
    },
    methods: {
        _getList() {
            const {
                SYS_LMDM_PRIOR_LEVEL,
                SYS_TMS_TRANSPORT_TYPE,
                SYS_SUPPLIER_YES_NO,
                SYS_TRANSPORT_TASK_STATUS
            } = sessionStorage;
            getList({
                ettaContractNo: this.ettaContractNo,
                ettaCarrierEbcuCode: this.supplier.supplierCode
            }).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.totalData = res.data.data.map(item => {
                            // 紧急程度
                            item.ettaLevelType = getSessionKey(item.ettaLevel, SYS_LMDM_PRIOR_LEVEL);
                            // 运输方式
                            item.ettaTranTypeNew = getSessionKey(item.ettaTranType, SYS_TMS_TRANSPORT_TYPE);
                            // 是否预约
                            item.ettaReservationType = getSessionKey(item.ettaReservation, SYS_SUPPLIER_YES_NO);
                            // 运输单状态
                            item.ettaStatusType = getSessionKey(item.ettaStatus, SYS_TRANSPORT_TASK_STATUS);
                            return item;
                        });
                    } else {
                        this.$message.error(res.data.messagesAsString);
                    }
                }
            });
        },
        // 绑定
        _bundDevice() {
            bundDevice({
                deviceName: this.ruleForm.deviceName,
                deviceContractNo: this.ettaContractNo,
                userName: this.user.userName,
                ettaCarrierEbcuCode: this.supplier.supplierCode
            }).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.$message.success('绑定成功!');
                        this._getList();
                    } else {
                        this.$message.error(res.data.messagesAsString);
                    }
                }
                this.saveLoading = false;
            });
        },
        // 回收
        _recallDevice() {
            const { deviceName } = this.ruleForm;
            recallDevice({
                deviceName
            }).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.$message.success('回收成功!');
                        this._getList();
                    } else {
                        this.$message.error(res.data.messagesAsString);
                    }
                }
                this.saveLoading = false;
            });
        },
        // 查询结果
        searchChange(val) {
            this.ettaContractNo = val.ettaContractNo;
            this._getList();
        },
        selectChange(val) {
            this.selectArray = val;
        },
        handleClose() {
            this.visible = false;
            this.ruleForm.deviceName = '';
            this.flagText = '';
            this.$refs.form.resetFields();
        },
        handleChange() {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.$message.error('请输入设备号!');
                    return false;
                } else {
                    this.saveLoading = true;
                    if (this.flagText === 'binding') {
                        this._bundDevice();
                    }
                    if (this.flagText === 'recycle') {
                        this._recallDevice();
                    }
                }
            });
        },
        binding() {
            if (!this.totalData.length) {
                this.$message.error('请先搜索合同编号在进行设备绑定!');
                return false;
            }
            this.visible = true;
            this.flagText = 'binding';
        },
        recycle() {
            this.visible = true;
            this.flagText = 'recycle';
        },
        pageChange(val) {
            this.currentPage = val;
            this._getList(val);
        },
        sizeChange(val) {
            this.pageSize = val;
            this._getList();
        }
    }
};
</script>
<style lang="less">

</style>